import { UPDATE_CUSTOMER } from 'customer/actions/actionTypes'
import { FETCH_USERS_DETAILS } from './actions'

const initialState = {
  details: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USERS_DETAILS:
      return {
        ...state,
        details: action.payload,
      }
    case UPDATE_CUSTOMER:
      return {
        ...state,
        details: action.payload,
      }
    default:
      return state
  }
}
